// File → wp-content/themes/donne-coop/src/js/custom-javascript.js

import StickyNavbar from "./modules/sticky-navbar";
import initCommissioniRegionaliFab from "./modules/commissioni-regionali-fab";
import initCDCGalleryGlightbox from "./modules/gallery-glightbox-init";
import initHeroSlider from "./modules/init-hero-slider";
import initMappaCommissioniRegionali from "./modules/mappa-commissioni-regionali";
import { initScrollReveal } from "./modules/scroll-reveal";


/**
 * Calcola l'altezza della bottom bar e la imposta come variabile CSS per non sovrapporre i contenuti
 * Usare var(--bottom-bar-height) in CSS
 * Filtro php 'body_class' aggiunge la classe '.has-bottom-bar' al body se la bottom bar è presente
 * Es. .has-bottom-bar { padding-bottom: var(--bottom-bar-height); }
 * 
 * @return {void}
 */
function setBottomBarHeight() {
    const bottomBar = document.querySelector(".bottom-bar");
    if (bottomBar) {
        const height = bottomBar.offsetHeight;
        document.documentElement.style.setProperty("--bottom-bar-height", `${height}px`);
    }
}

// Quando il DOM è completamente caricato...
document.addEventListener("DOMContentLoaded", function () {

    console.log("Theme Child → DOM pronto 👍");

    // Inizializza la Navbar sticky
    StickyNavbar.initialize("mainNavbar");

    // Imposta l'altezza iniziale della barra in basso se presente
    setBottomBarHeight();

    // Inizializza lo slider Hero, attivato solo se necessario
    initHeroSlider(".swiper-hero-slider");

    // Inizializza GLightbox per le gallerie immagini
    initCDCGalleryGlightbox(".glightbox-item");

    // Inizializza le animazioni allo scroll (Intersection Observer)
    initScrollReveal();

    // Inizializza la mappa delle Commissioni regionali, se presente
    document
        .querySelectorAll("[data-commissioni-regionali-map]")
        .forEach((wrapper) => initMappaCommissioniRegionali(wrapper));

    // Inizializza il pulsante rapido verso la mappa delle Commissioni regionali
    document
        .querySelectorAll("[data-commissioni-map-fab]")
        .forEach((button) => initCommissioniRegionaliFab(button));
});
